<template>
    <div class="order">
        <div class="flex__between__center header" v-link="'/Address/Index'">
            <div class="flex__column" v-if="orders.linkman">
                <span class="fs_34 c_1a lh_50">{{orders.linkman}}&emsp;{{orders.mobile_phone}}</span>
                <span class="fs_28 c_80 lh_40">{{orders.province}}{{orders.city}}{{orders.area}}{{orders.address}}</span>
            </div>
            <span v-else class="fs_28 c_ 80 lh_40">请选择地址</span>
            <span class="jcicon jcicon-jiantouarrow487 fs_26 c_98"></span>
        </div>
        <div class="sale-box">
            <div class="flex sale__item" v-for="(item,index) in cart_product" :key="index">
                <img :src="item.cover_img" alt="">
                <div class="flex__null__around sale__item__right">
                    <span class="fs_26 c_1a lh_36 ellipsis_two">{{item.name}}</span>
                    <span class="fs_22 c_98" v-if="item.product_sku">规格: {{item.product_sku_name}}</span>
                    <div class="flex__between">
                        <span class="fs_30 c_main"><span class="fs_22">¥</span>{{item.price}}</span>
                        <span class="fs_26 c_80">x{{item.number}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 附带信息 -->
        <div class="modular-box">
            <div class="flex__between__center modular__item">
                <span class="fs_28 c_1a">商品合计</span>
                <span class="fs_30 c_main"><span class="fs_22">¥</span>{{goods_amount}}</span>
            </div>
            <div class="flex__between__center modular__item">
                <span class="fs_28 c_1a">运费</span>
                <span class="fs_28 c_4d" v-if="freight">{{freight}}</span>
                <span class="fs_28 c_4d" v-else>{{freight_name}}</span>
            </div>
            <div class="flex__between__center modular__item" @click="setPrice">
                <span class="fs_28 c_1a">优惠券</span>
                <div class="lh_40">
                    <span class="fs_30 c_main" v-if="coupon.price"><span class="fs_22">-¥</span>{{coupon.price}}</span>
                    <span class="fs_28 c_80" v-else>请选择</span>
                    <span class="jcicon jcicon-jiantouarrow487 fs_26 c_98"></span>
                </div>
            </div>
            <div class="flex__between__center modular__item">
                <span class="fs_28 c_1a">备注</span>
                <input type="text" v-model="orders.remark" class="fs_28 c_4d" placeholder="请输入备注"/>
            </div>
        </div>
        <!-- 支付方式 -->
        <div class="modular-box" @click="picker_show=true">
            <div class="flex__between__center modular__item">
                <span class="fs_28 c_1a">支付方式</span>
                <div class="lh_40">
                    <span class="fs_28 c_4d">{{pay_way[way_index].name}}</span>
                    <span class="jcicon jcicon-jiantouarrow487 fs_26 c_98"></span>
                </div>
            </div>
        </div>
        <!-- 支付方式picker -->
        <div class="picker-box" v-show="picker_show">
            <div class="layer" @click="picker_show=false"></div>
            <van-picker 
            class="van-picker" 
            show-toolbar
            :columns="pay_way" 
            value-key="name"
            @cancel="picker_show=false"
            @confirm="setPayway" />
        </div>
        <!-- 底部操作栏 -->
        <div class="flex__between__center footer">
            <div>
                <span class="fs_28 c_4d">实付：</span>
                <span class="c_main fs_24">¥</span>
                <span class="c_main fs_30">{{pay_goods_amount}}</span>
            </div>
            <button class="cancel" @click="pay">去付款</button>
        </div>
    </div>
</template>
<script>
export default {
    name: "Order",
    data(){
        return{
            coupon: {},
            way_index: 0, //支付方式
            picker_show: false, //picker显示
            cart_product: [],
            pay_goods_amount: 0,
            goods_amount: 0,
            pay_way:[{}],
            freight_name: '',
            freight: '',
            orders:{
                user_id: localStorage.user_id, //
                source: 1, //来源（非必填,1-微信公众号 2-小程序 默认为小程序）
                settlement_type: 1, //结算方式（必填 1：购物车结算 2：立即购买）
                product_id: '', //立即购买商品ID（当 settlement_type = 2 时 必填）
                linkman: '', //联系人（必填）
                mobile_phone: '', //联系电话（必填）
                province: '', //省（必填）
                city: '', //市（必填）
                area: '', //区（必填）
                address: '', //详细地址（必填）
                address_id: '',
                number: '', //立即购买商品数量（当 settlement_type = 2 时 必填）
                sku: '', //立即购买商品SKU编码（当 settlement_type = 2 且商品你开启规格时 必填）
                my_coupon_id: '', //用户优惠券ID（非必填）
                pay_way: 1, //支付方式ID（必填 1--微信支付 2--余额支付）
                form_id: '', //表单ID（当pay_way = 2 时 必填）
                remark: '', //备注（非必填）
            }
        }
    },
    methods:{
        // 付款
        pay(){
            if(!this.orders.address_id){
                this.$toast('请选择地址');
                return;
            }
            this.httpPost({
                url:'/Mall/submitOrder',
                params:this.orders
            }).then(res=>{
                if(res.code==1){
                    if(this.orders.pay_way==1){
                        if(res.data.pay_parameters){
                            this.$wx.wxPay(res.data.pay_parameters).then(api_res => {
                                this.$router.push('/Mall/MyOrder?index=2');
                            }).catch(api_res=>{
                                this.$router.push('/Mall/MyOrder?index=1');
                            })
                        }else{
                            this.$router.push('/Mall/MyOrder?index=2');
                        }
                    }else{
                        this.$dialog.alert({
                            message: res.message
                        }).then(()=>{
                            this.$router.push('/Mall/MyOrder?index=2');
                        })
                    }
                }else{
                    this.$dialog.alert({
                        message: res.message
                    })
                }
            })
        },
        // 支付方式
        setPayway(value,index){
            this.picker_show=false;
            this.way_index=index;
            this.orders.pay_way=this.pay_way[index].id;
        },
        setPrice(){
            this.$store.commit('setPrice',this.goods_amount);
            this.$router.push('/Coupon/Choose');
        },
        // 获取地址
        getAddress(id){
            this.axios.post('/wechat.php/Address/getAddressData', {
                user_id: localStorage.user_id,
                id: id
            }).then(
                res=>{
                    this.orders.province=res.data.data.province;
                    this.orders.city=res.data.data.city;
                    this.orders.area=res.data.data.area;
                    this.orders.address=res.data.data.address;
                    this.orders.linkman=res.data.data.linkman;
                    this.orders.mobile_phone=res.data.data.mobile_phone;
                    this.orders.address_id=res.data.data.id;
                }
            )
        }
    },
    mounted(){
        this.orders.settlement_type=this.$route.query.settlement_type;
        this.orders.product_id=this.$route.query.product_id;
        this.orders.number=this.$route.query.number;
        this.orders.sku=this.$route.query.sku;
        this.axios.post('/wechat.php/Mall/getOrderReady', {
            user_id: localStorage.user_id,
            settlement_type: this.$route.query.settlement_type,
            product_id: this.$route.query.product_id,
            number: this.$route.query.number,
            sku: this.$route.query.sku,
        }).then(
            res=> {
                // 计算优惠券
                this.goods_amount=res.data.data.goods_amount;
                if(JSON.stringify(this.$store.state.coupon)=='{}'){
                    this.orders.my_coupon_id='';
                    this.pay_goods_amount=this.goods_amount;
                }else{
                    this.coupon=this.$store.state.coupon;
                    this.$store.commit('setCoupon',{});
                    this.orders.my_coupon_id=this.coupon.id;
                    let money =Number(this.goods_amount)-Number(this.coupon.price);
                    this.pay_goods_amount = money.toFixed(2);
                }
                this.cart_product=res.data.data.cart_product;
                this.freight=res.data.data.freight;
                this.freight_name=res.data.data.freight_name;
                // 默认地址
                if(this.$store.state.address_id){
                    // 通过id获取地址
                    this.getAddress(this.$store.state.address_id);
                }else{
                    this.orders.province=res.data.data.default_address.province;
                    this.orders.city=res.data.data.default_address.city;
                    this.orders.area=res.data.data.default_address.area;
                    this.orders.address=res.data.data.default_address.address;
                    this.orders.linkman=res.data.data.default_address.linkman;
                    this.orders.mobile_phone=res.data.data.default_address.mobile_phone;
                    this.orders.address_id=res.data.data.default_address.id;
                }
                this.pay_way=res.data.data.pay_way;
                // 算运费的金额
                if(this.freight){
                    let money =Number(this.pay_goods_amount) + Number(this.freight);
                    this.pay_goods_amount=money.toFixed(2);
                }
            }) 
    },
    destroyed(){
        this.$store.commit('setAddressId','');
        this.$store.commit('setCoupon',{});
    }
}
</script>
<style scoped>
.header{
    padding: 30px;
    background: #fff;
}
.sale-box{
    padding: 0 30px 30px;
    margin-top: 15px;
    background: #fff;
    overflow: hidden;
}
.sale__item{
    margin-top: 30px;
}
.sale__item:last-child{
    border: 0;
}
.sale__item img{
    width: 180px;
    height: 180px;
    border-radius: 10px;
}
.sale__item__right{
    width: 480px;
    margin-left: 30px;
}
/* info */
.modular-box{
    padding: 0 30px;
    margin-top: 15px;
    background: #fff;
}
.modular__item{
    height: 100px;
    border-bottom: 2px solid #e6e6e6;
}
.modular__item:last-child{
    border: 0;
}
.modular__item input{
    width: 500px;
    text-align: right;
}
/* footer */
.footer{
    position: fixed;
    width: 100%;
    bottom: 0;
    padding-left: 30px;
    height: 98px;
    background: #fff;
}
.footer__left{
    padding: 0 30px;
}
.cancel{
    width: 250px;
    height: 98px;
    margin-left: 30px;
    background: #F93A42;
    color: #fff;
    font-size: 32px;
}
/* modal */
.picker-box{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    z-index: 1;
}
.layer{
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    z-index: 1;
}
.van-picker{
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: 2;
}
</style>





// WEBPACK FOOTER //
// src/pages/mall/Order.vue